import * as React from 'react';
import { find } from 'lodash';
import { setSort } from '../../actions/index';
import { ISort } from '../../state-helpers/sorts';
import { IEpiProps } from '../../state-helpers/epi-props';
import { addUrlProps, UrlQueryParamTypes } from 'react-url-query';
import { connect } from 'react-redux';
import * as ReactCreateClass from 'create-react-class';

import { SortGroup } from '../../../../App/global/components/inputs/sort/sort';
import { IGlobalSort } from '../../../../App/global/state-helpers/sort';
import { IResults } from '../../state-helpers/search-results';


export interface ISortsProps {
    sorts: ISort[];
    onSortSelect: (sortId: string) => void;
    epiProps: IEpiProps;
}


export interface ISortProps {
    sort: ISort;
    key: any;
    epiProps: IEpiProps;
    groupName: any;
}

const urlPropsQueryConfig = {
    queryCurrentSort: { type: UrlQueryParamTypes.string, queryParam: "sort" },
}

function mapStateToProps(state, props) {
    return {
        currentPage: state.sortsModel.sortId,
    };
}

/**
 * Standard react-redux mapDispatchToProps
 */
function mapDispatchToProps(dispatch) {
    return {
        sortSelectProp: (sortId) => dispatch(setSort(sortId)),
    };
}


export function GetSorts(sortsModel: ISort[], epiProps: IEpiProps): IGlobalSort<IResults>[]  {
    return sortsModel.map((sort, i, arr) => {
        let newSort: IGlobalSort<IResults> = {
            display: getDisplayName(sort.id, epiProps),
            sortId: sort.id,
            selected: sort.selected
        };
        return newSort;
    });
}

//export const Sort = ReactCreateClass<ISortProps, any>({
//    render: function () {
//        let uniqueId = this.props.sort.id + '-' + this.props.groupName;
//        return (
//            <div className="search-sort-list-item">
//                <input type="radio" value={this.props.sort.id} id={uniqueId} checked={this.props.sort.selected} name={this.props.groupName} />
//                <label htmlFor={uniqueId}>{getDisplayName(this.props.sort.id, this.props.epiProps)}</label>
//            </div>
//        );
//    },
//});

function getDisplayName(id: string, epiProps: IEpiProps) {
    switch (id) {
        case 'relevance':
            return epiProps.relevantSortText;
        case 'title':
            return epiProps.alphabeticalSortText;
        case 'rTitle':
            return epiProps.reverseAlphabeticalSortText;
        case 'newest':
            return epiProps.newestToOldestSortText;
        case 'oldest':
            return epiProps.oldestToNewestSortText;
    }
}


//export class Sorts extends React.Component<ISortsProps, any> {

//    constructor(props) {
//        super(props);

//        if (props.queryCurrentSort) {
//            props.sortSelectProp(props.queryCurrentSort);
//        }
//    }

//    render() {
//        let groupInputName = 'sort-desktop';
//        return (
//            <div className="search-sort">
//                <fieldset onChange={(ev) => this.props.onSortSelect((ev.target as any).value)}
//                    ref="fieldset">
//                    <div className="search-sort-list">
//                        {this.props.sorts.map((s, index) => <Sort key={index} sort={s} epiProps={this.props.epiProps} groupName={groupInputName} />)}
//                    </div>

//                </fieldset>
//            </div>
//        );
//    }

//    componentWillReceiveProps(newProps: ISortsProps) {
//        const select = this.refs['fieldset'] as any;
//        select.value = find(newProps.sorts, s => s.selected).id;
//    }
//}

//export var ConnectedSorts = addUrlProps({ urlPropsQueryConfig })(connect(mapStateToProps, mapDispatchToProps)(Sorts));